var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        position: "relative",
        display: "flex",
        "min-height": "110px"
      }
    },
    [
      _c("quill-editor", {
        ref: "cargoRichTextarea",
        class: _vm.editorClass,
        attrs: {
          value: _vm.content,
          disabled: _vm.disabled,
          options: _vm.editorOption
        },
        on: {
          change: _vm.onChange,
          ready: _vm.quillReady,
          blur: _vm.handleBlur
        }
      }),
      _vm.maxCount && _vm.showCount
        ? _c("span", { staticClass: "length-limit" }, [
            _vm._v(
              _vm._s(
                (_vm.displayLength <= _vm.maxCount
                  ? _vm.displayLength
                  : _vm.maxCount) +
                  "/" +
                  _vm.maxCount
              )
            )
          ])
        : _vm.showCount
        ? _c("span", { staticClass: "length-limit" }, [
            _vm._v(_vm._s(_vm.displayLength) + "字")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }